module.exports = {
      id: "illustrations:search-usage",
      viewBox: "0 0 294 330",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:search-usage",
      toString: function () {
        return this.url;
      }
    }